export default {"src":"/_next/static/image/public/images/ic_bookmark_checked_green.5b33e42f082d43cc306054ab19716baf.svg","height":18,"width":14};